(() => {
  function init(root) {
    const media = window.matchMedia('(min-width: 821px)');
    root.querySelectorAll('[data-nt-collection]').forEach(catalog => {
      if (catalog.dataset.viewReady) return;
      catalog.dataset.viewReady = 'true';
      let layout = 'list';
      try {
        const saved = window.localStorage.getItem('nt_catalog_mobile_layout');
        if (saved === 'grid' || saved === 'list') layout = saved;
      } catch {}
      const buttons = catalog.querySelectorAll('[data-nt-catalog-view]');
      const applyLayout = value => {
        catalog.dataset.ntMobileLayout = value;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ntCatalogView === value)));
      };
      applyLayout(layout);
      buttons.forEach(button => button.addEventListener('click', () => {
        const value = button.dataset.ntCatalogView;
        applyLayout(value);
        try { window.localStorage.setItem('nt_catalog_mobile_layout', value); } catch {}
      }));
    });
    root.querySelectorAll('[data-nt-stock-guarantee]').forEach(panel => {
      if (panel.dataset.catalogReady) return;
      panel.dataset.catalogReady = 'true';
      const summary = panel.querySelector('summary');
      const setMode = () => {
        panel.open = media.matches;
        summary.tabIndex = media.matches ? -1 : 0;
      };
      summary.addEventListener('click', event => { if (media.matches) event.preventDefault(); });
      setMode(); media.addEventListener('change', setMode);
    });
    root.querySelectorAll('[data-nt-catalog-back-top]').forEach(button => {
      if (button.dataset.catalogReady) return;
      button.dataset.catalogReady = 'true';
      button.addEventListener('click', () => {
        if (!media.matches) {
          root.querySelectorAll('[data-nt-catalog-filters]').forEach(panel => {
            panel.dispatchEvent(new Event('nt:catalog-return-top'));
          });
        }
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    root.querySelectorAll('[data-nt-catalog-filters]').forEach(panel => {
      if (panel.dataset.catalogReady) return;
      panel.dataset.catalogReady = 'true';
      let filterMotion;
      let targetOpen = panel.open;
      const setPanelOpen = (open, animate = false) => {
        filterMotion?.cancel();
        filterMotion = undefined;
        const startHeight = panel.getBoundingClientRect().height;
        targetOpen = open;
        panel.open = open;
        if (!animate || media.matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
          panel.style.removeProperty('overflow');
          return;
        }
        const endHeight = panel.getBoundingClientRect().height;
        if (Math.abs(endHeight - startHeight) < 1) return;
        if (!open) panel.open = true;
        panel.style.overflow = 'hidden';
        const motion = panel.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: open ? 260 : 200, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
        filterMotion = motion;
        motion.onfinish = () => {
          if (filterMotion !== motion) return;
          panel.open = open;
          panel.style.removeProperty('overflow');
          filterMotion = undefined;
        };
      };
      let canAutoCollapse = false;
      let scrollIntent = false;
      let upwardIntent = false;
      let touchY = null;
      let lastScrollY = window.scrollY;
      let downwardDistance = 0;
      const setMode = (animate = false) => {
        setPanelOpen(true, animate === true);
        canAutoCollapse = true;
        scrollIntent = false;
        upwardIntent = false;
        lastScrollY = window.scrollY;
        downwardDistance = 0;
      };
      panel.addEventListener('nt:catalog-return-top', () => setMode(true));
      panel.querySelector('summary')?.addEventListener('click', event => {
        if (!media.matches) {
          event.preventDefault();
          setPanelOpen(!targetOpen, true);
        }
        canAutoCollapse = true;
        scrollIntent = false;
        upwardIntent = false;
        lastScrollY = window.scrollY;
        downwardDistance = 0;
      });
      window.addEventListener('wheel', event => {
        if (event.deltaY > 0) { scrollIntent = true; upwardIntent = false; }
        else if (event.deltaY < 0) upwardIntent = true;
      }, { passive: true });
      window.addEventListener('touchstart', event => { touchY = event.touches[0]?.clientY ?? null; }, { passive: true });
      window.addEventListener('touchmove', event => {
        const nextY = event.touches[0]?.clientY;
        if (nextY !== undefined && touchY !== null) {
          if (nextY < touchY) { scrollIntent = true; upwardIntent = false; }
          else if (nextY > touchY) upwardIntent = true;
        }
        touchY = nextY ?? null;
      }, { passive: true });
      window.addEventListener('keydown', event => {
        if (event.target.closest('input,select,textarea,button,summary')) return;
        if (['ArrowDown', 'PageDown', 'End', ' '].includes(event.key)) { scrollIntent = true; upwardIntent = false; }
        else if (['ArrowUp', 'PageUp', 'Home'].includes(event.key)) upwardIntent = true;
      });
      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const delta = scrollY - lastScrollY;
        lastScrollY = scrollY;
        if (!media.matches && scrollY <= 8 && delta < 0 && upwardIntent && !panel.open) {
          setMode(true);
          return;
        }
        if (media.matches || !canAutoCollapse || !scrollIntent || !panel.open || !panel.isConnected) return;
        downwardDistance = delta > 0 ? downwardDistance + delta : 0;
        const stickyTop = parseFloat(window.getComputedStyle(panel).top) || 0;
        if (downwardDistance >= 64 && panel.getBoundingClientRect().top <= stickyTop + 2) {
          setPanelOpen(false, true);
          canAutoCollapse = false;
        }
      }, { passive: true });
      setMode(); media.addEventListener('change', setMode);
    });
    root.querySelectorAll('[data-nt-catalog-about]').forEach(panel => {
      if (panel.dataset.catalogReady) return;
      panel.dataset.catalogReady = 'true';
      const setMode = () => { panel.open = false; };
      setMode(); media.addEventListener('change', setMode);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
